module.exports = __webpack_public_path__ + "static/media/beacon.6cada1df.svg";